import { useEffect, useRef, useState } from "react";
import { useGuardianFormHandlers } from "./useGuardianFormHandlers";

/**
 * Bond Retrieval guardian forms — dataRef, SSN toggle, shared handler façade (Phase 4).
 */
export function useRetrievalGuardianFormSetup({
  bondKind,
  data,
  updateData,
  attorneys,
  joinEmploymentOccupation,
}) {
  const [showSSNStates, setShowSSNStates] = useState({});
  const dataRef = useRef(data);
  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  const toggleShowSSN = (index) => {
    setShowSSNStates((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handlers = useGuardianFormHandlers({
    bondKind,
    data,
    updateData,
    attorneys,
    dataRef,
    joinEmploymentOccupation,
  });

  return { showSSNStates, toggleShowSSN, handlers };
}
